/**
 * QuestionarioIntroBanner
 *
 * Banner informativo mostrato in testa ai questionari assuntivi (D&O, Cyber, ecc.)
 * Spiega perché il questionario è articolato e che verranno elaborati preventivi
 * multipli in ottica di best execution / trasparenza IVASS.
 *
 * Testo generico — riutilizzabile per tutti i wizard senza props obbligatorie.
 * Il prop `ramoRischio` è opzionale e viene usato solo per differenziare il
 * `data-testid` del banner (utile per QA/testing).
 */
import React from "react";
import { Info } from "lucide-react";

export default function QuestionarioIntroBanner({ ramoRischio = "generico" }) {
  const slug = String(ramoRischio).toLowerCase().replace(/[^a-z0-9]/g, "-");
  const testId = `intro-banner-${slug}`;
  return (
    <aside
      role="note"
      aria-label="Introduzione al questionario unificato Colucci Assicuratori"
      data-testid={testId}
      className="mb-6 rounded-2xl border border-[#D9C49A] bg-[#FDF8E8] p-5 sm:p-6"
    >
      <div className="flex items-start gap-3 sm:gap-4">
        <div
          className="shrink-0 w-10 h-10 rounded-xl bg-[#163321] text-[#D9C49A] flex items-center justify-center"
          aria-hidden="true"
        >
          <Info className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0 space-y-2.5">
          <h2 className="font-heading text-base sm:text-lg text-[#0F1F14] font-semibold leading-snug">
            Questionario unificato Colucci Assicuratori
          </h2>
          <p className="text-sm text-[#3A4C42] leading-relaxed">
            Il presente questionario è stato predisposto da{" "}
            <strong className="text-[#0F1F14]">Colucci Assicuratori</strong> per
            raccogliere in un unico modulo tutte le informazioni richieste dalle{" "}
            <strong className="text-[#0F1F14]">
              principali compagnie assicurative
            </strong>{" "}
            operanti su questo ramo di rischio.
          </p>
          <p className="text-sm text-[#3A4C42] leading-relaxed">
            La compilazione può risultare articolata perché copre in modo
            esaustivo i requisiti informativi di{" "}
            <strong className="text-[#0F1F14]">più assuntori</strong>,
            permettendo così di elaborare{" "}
            <strong className="text-[#0F1F14]">preventivi multipli</strong> e
            comparare in modo trasparente coperture, franchigie, massimali e
            premi.
          </p>
          <p className="text-sm text-[#3A4C42] leading-relaxed">
            Al termine, il nostro team analizzerà i dati con l&apos;obiettivo di
            individuare la{" "}
            <strong className="text-[#0F1F14]">
              soluzione economicamente più vantaggiosa
            </strong>{" "}
            e tecnicamente più adeguata al vostro profilo di rischio, nel pieno
            rispetto dei doveri di{" "}
            <strong className="text-[#0F1F14]">best execution</strong> e di{" "}
            <strong className="text-[#0F1F14]">trasparenza informativa</strong>{" "}
            previsti dalla normativa IVASS.
          </p>
        </div>
      </div>
    </aside>
  );
}
